import { useEffect, useState } from 'react';
import { CircularProgress, Button, Typography, Card, CardContent, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { getProfile, isLoggedIn, signOut } from '../../data';

export default function Profile(props) {
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'center',
            minHeight: 400,
            minWidth: 600,
        },
        grid: {
            maxWidth: 400,
            flex: 'auto',
        },
        textField: {
            display: 'flex-item',
            width: 200,
            margin: theme.spacing(2),
        },
        button: {
            display: 'flex-item',
            width: 200,
            margin: theme.spacing(2),
        }
    }));
    const classes = useStyles();

    const [loading, setLoading] = useState(true);
    const [profile, setProfile] = useState({});
    const [recognized, setRecognized] = useState(false);

    useEffect(() => {
        (async () => {
            const recognized = await isLoggedIn();
            setRecognized(recognized);
            if (recognized) {
                setProfile(await getProfile());
            }
            setLoading(false);
        })();
    }, []);

    const notSignedInView = () => {
        return (
            <Card className={classes.root}>
                <CardContent className={classes.grid}>
                    <Typography variant="h6" component="h6">
                        Sign-in to access your profile
                    </Typography>
                    <Link to={'/'} >
                        <Button variant='contained' color='primary' className={classes.button}>
                            SIGN IN
                        </Button>
                    </Link>
                </CardContent>
            </Card>
        )
    };

    const signOutHandler = () => {
        signOut();
        window.location = '/';
    };

    const signedInView = () => {
        return (
            <Card className={classes.root}>
                <CardContent className={classes.grid}>
                    <Typography>profileId: {profile.profileId}</Typography>
                    <Typography>displayName: {profile.displayName}</Typography>
                    <Button variant='contained' color='primary' className={classes.button} onClick={signOutHandler}>
                        SIGN OUT
                    </Button>
                </CardContent>
            </Card>
        )
    };

    return (
        <div className={classes.root}>
            {loading && <CircularProgress />}
            {!recognized && notSignedInView()}
            {recognized && signedInView()}
        </div>
    )
};